import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const CarouselNextArrow = ({ className, onClick }) => {
    return (
        <button
            className={className}
            onClick={onClick}
            aria-label="Next Arrow">
            <div className="carousel-arrow">
                <FontAwesomeIcon icon="arrow-right" />
            </div>
        </button>
    )
}

export default CarouselNextArrow
